import type { SavedTakeProfitOrder } from '@/domain/WorkspaceForex/savedProducts/order/SavedTakeProfitOrder.ts';
import type { TakeProfitOrder } from '@/store/orders/takeProfitOrder/state.ts';

export const mapToTakeProfit = (savedTile: SavedTakeProfitOrder): TakeProfitOrder => {
  return {
    ...savedTile,
    properties: {
      ...savedTile.properties,
    },
  };
};
